import api from "./api";
import { supplierType } from "../components/Suppliers/types";
export type DeleteSupplierDto = {
  id: number | string;
  type?: string;
};

/*Search & filter */

export const getSuppliers = async (Dto: {
  q?: string,
  limit?: number,
  offset?: number,
  isActive?: boolean | undefined
}) => {
  const queryParams: Record<string, string> = {};

  if (Dto.q) {
    queryParams.q = Dto.q;
  }

  if (Dto.limit) {
    queryParams.limit = Dto.limit.toString();
  }

  if (Dto.offset) {
    queryParams.offset = Dto.offset.toString();
  }

  if (Dto.isActive !== undefined) {
    queryParams.isActive = Dto.isActive.toString();
  }

  const queryString = Object.keys(queryParams)
    .map(key => `${key}=${queryParams[key]}`)
    .join('&');

  const url = `/suppliers${queryString ? `?${queryString}` : ''}`;

  return await api.get(url);
}

export const getSupplier = async () => {
  return await api.get("/suppliers");
};

/*select customer */
export const getSupplierDropdown = async () => {
  return await api.get("/suppliers/dropdown");
};
export const getSupplierDropdownFiltered = async (hasBill: boolean) => {
  return await api.get(`/suppliers/dropdown?hasBill=${hasBill}`);
};

/*delete customer */

export const deleteSupplier = async (dto: DeleteSupplierDto) => {
  return await api.delete(`/suppliers/${dto.id}`);
};

/*get customer by id */

export const getSupplierById = async (SuppliersId: string | undefined) => {
  return await api.get(`/suppliers/${SuppliersId}`);
};

export const getSupplierBalance = async (Dto: {
  supplierId: number,
  limit?: number,
  offset?: number,
  from?: string,
  to?: string
}) => {
  const queryParams: Record<string, string> = {};

  if (Dto.limit) {
    queryParams.limit = Dto.limit.toString();
  }

  if (Dto.offset) {
    queryParams.offset = Dto.offset.toString();
  }

  if (Dto.from) {
    queryParams.from = Dto.from.toString();
  }

  if (Dto.to) {
    queryParams.to = Dto.to.toString();
  }

  const queryString = Object.keys(queryParams)
    .map(key => `${key}=${queryParams[key]}`)
    .join('&');

  const url = `/suppliers/supplier-balance/${Dto.supplierId}${queryString ? `?${queryString}` : ''}`;
  return await api.get(url);
}

/*create customer */

export const createSupplier = async (supplierDetails: supplierType) => {
  return await api.post("/suppliers", supplierDetails);
};

/*edit customer */

export const editSupplier = async (supplierId: any, body: supplierType) => {
  return await api.put(`/suppliers/${supplierId}`, body);
};

export const deleteSupplierTransaction = async (dto: DeleteSupplierDto) => {
  return await api.delete(`/suppliers/transaction/${dto.type}/${dto.id}`)
};